import dayjs from 'dayjs';
import { FormattedMessage } from 'react-intl';

// font size
export const ORIGINAL_FONT_SIZE = '16px';
export const EXTREME_SMALL_FONT_SIZE = '1.1rem';
export const EXTRA_SMALL_FONT_SIZE = '1.25rem';
export const SMALL_FONT_SIZE = '1.3rem';
export const NORMAL_FONT_SIZE = '1.4rem';
export const MEDIUM_FONT_SIZE = '1.6rem';
export const LARGE_FONT_SIZE = '1.8rem';

// print size
export const A4_PRINT_SIZE = '@page { size: A4 landscape; width: 594mm; height: 420mm; }';
// "@page { size: A4 landscape; width: 594mm; height: 460mm;  }";

export const formatUTC = (value: string, format: string) => {
  if (!value) return '';
  return dayjs.utc(value).local().format(format);
};

interface CellType {
  label: string;
  width?: string;
  rowSpan?: number;
  colSpan?: number;
}

export interface RenderedCell extends Omit<CellType, 'label'> {
  label: JSX.Element;
}

export const renderCell = ({ label, width, rowSpan, colSpan }: CellType) => {
  const cell: RenderedCell = {
    label: <FormattedMessage id={label} />,
    rowSpan,
    colSpan,
    width,
  };

  return cell;
};

export const sharedPrintTableStyles = {
  mt: 2,
  '& td,th': {
    border: '0.5px solid',
    textAlign: 'center',
    padding: 1,
  },
  '@media print': {
    '& table': {
      borderCollapse: 'collapse',
    },
    '& td,th': {
      background: 'none',
      color: 'black',
    },
    '& thead': {
      background: 'none',
    },
    '& td, & th': {
      padding: '0px',
    },
  },
};

// màn Thực đơn dinh dưỡng
export const setFontSize = (caloriesIncluded: boolean, eatingDays: number) => {
  const fiveDays = {
    noCalories: !caloriesIncluded && eatingDays === 5,
    withCalories: caloriesIncluded && eatingDays === 5,
  };
  const sixDays = {
    noCalories: !caloriesIncluded && eatingDays === 6,
    withCalories: caloriesIncluded && eatingDays === 6,
  };

  if (fiveDays.noCalories) {
    return NORMAL_FONT_SIZE;
  } else if (fiveDays.withCalories) {
    return SMALL_FONT_SIZE;
  } else if (sixDays.noCalories) {
    return EXTRA_SMALL_FONT_SIZE;
  }
  // 6 ngày có calories
  return EXTRA_SMALL_FONT_SIZE;
};

// màn Thực đơn giáo viên
export const setFontSizeTeacherMenuForm = (caloriesIncluded: boolean, eatingDays: number) => {
  const fiveDays = {
    noCalories: !caloriesIncluded && eatingDays === 5,
    withCalories: caloriesIncluded && eatingDays === 5,
  };
  const sixDays = {
    noCalories: !caloriesIncluded && eatingDays === 6,
    withCalories: caloriesIncluded && eatingDays === 6,
  };

  if (fiveDays.noCalories) {
    return NORMAL_FONT_SIZE;
  } else if (fiveDays.withCalories) {
    return SMALL_FONT_SIZE;
  } else if (sixDays.noCalories) {
    return EXTRA_SMALL_FONT_SIZE;
  }
  return EXTREME_SMALL_FONT_SIZE;
};
